import React, { useState, Fragment } from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { CheckCircle, ArrowRight, ArrowLeft } from 'lucide-react';
export const LoanApplicationPage = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [loanType, setLoanType] = useState('');
  const steps = [{
    number: 1,
    title: 'Personal & Loan Details'
  }, {
    number: 2,
    title: 'Collateral & Documentation'
  }];
  return <div className="min-h-screen flex flex-col bg-gray-50" data-id="element-1702">
      <Header data-id="element-1703" />

      <main id="main-content" className="flex-grow py-12" role="main" data-id="element-1704">
        <div className="container" data-id="element-1705">
          <div className="max-w-4xl mx-auto" data-id="element-1706">
            {/* Progress Steps */}
            <div className="mb-12" data-id="element-1707">
              <div className="flex items-center justify-between" data-id="element-1708">
                {steps.map((step, index) => <Fragment key={step.number} data-id="element-1709">
                    <div className="flex flex-col items-center flex-1" data-id="element-1710">
                      <div className={`w-12 h-12 rounded-full flex items-center justify-center font-bold transition-all duration-300 ${currentStep >= step.number ? 'bg-primary-600 text-white' : 'bg-gray-200 text-gray-500'}`} aria-label={`Step ${step.number}: ${step.title}`} aria-current={currentStep === step.number ? 'step' : undefined} data-id="element-1711">
                        {currentStep > step.number ? <CheckCircle size={24} aria-hidden="true" data-id="element-1712" /> : step.number}
                      </div>
                      <p className="text-sm font-semibold mt-2 text-center" data-id="element-1713">
                        {step.title}
                      </p>
                    </div>
                    {index < steps.length - 1 && <div className={`flex-1 h-1 mx-4 transition-all duration-300 ${currentStep > step.number ? 'bg-primary-600' : 'bg-gray-200'}`} aria-hidden="true" data-id="element-1714" />}
                  </Fragment>)}
              </div>
            </div>

            {/* Form Content */}
            <div className="bg-white rounded-2xl shadow-lg p-8" data-id="element-1715">
              <form data-id="element-1716">
                {currentStep === 1 && <div className="space-y-6" data-id="element-1717">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1718">
                      Personal & Loan Details
                    </h2>

                    {/* Personal Information */}
                    <div className="grid md:grid-cols-2 gap-6" data-id="element-1719">
                      <div data-id="element-1720">
                        <label htmlFor="fullName" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1721">
                          Full Name *
                        </label>
                        <input type="text" id="fullName" name="fullName" autoComplete="name" required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="John Doe" data-id="element-1722" />
                      </div>

                      <div data-id="element-1723">
                        <label htmlFor="email" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1724">
                          Email Address *
                        </label>
                        <input type="email" id="email" name="email" autoComplete="email" required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="john@example.com" data-id="element-1725" />
                      </div>
                    </div>

                    <div className="grid md:grid-cols-2 gap-6" data-id="element-1726">
                      <div data-id="element-1727">
                        <label htmlFor="phoneNumber" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1728">
                          Phone Number *
                        </label>
                        <input type="tel" id="phoneNumber" name="phoneNumber" autoComplete="tel" required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="+254 700 000 000" data-id="element-1729" />
                      </div>

                      <div data-id="element-1730">
                        <label htmlFor="nationalId" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1731">
                          National ID Number *
                        </label>
                        <input type="text" id="nationalId" name="nationalId" autoComplete="off" required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="12345678" data-id="element-1732" />
                      </div>
                    </div>

                    <div data-id="element-1733">
                      <label htmlFor="address" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1734">
                        Physical Address *
                      </label>
                      <input type="text" id="address" name="address" autoComplete="street-address" required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="123 Main Street, Nairobi" data-id="element-1735" />
                    </div>

                    {/* Loan Details */}
                    <div className="border-t border-gray-200 pt-6 mt-6" data-id="element-1736">
                      <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1737">
                        Loan Information
                      </h3>

                      <div data-id="element-1738">
                        <label htmlFor="loanType" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1739">
                          Loan Type *
                        </label>
                        <select id="loanType" name="loanType" value={loanType} onChange={e => setLoanType(e.target.value)} required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" data-id="element-1740">
                          <option value="" data-id="element-1741">Select loan type...</option>
                          <option value="logbook" data-id="element-1742">
                            Fast Cash Logbook Loan
                          </option>
                          <option value="business" data-id="element-1743">
                            Secured Business Loan
                          </option>
                          <option value="asset" data-id="element-1744">Car & Asset Financing</option>
                          <option value="trade" data-id="element-1745">Trade Finance</option>
                        </select>
                      </div>

                      <div className="grid md:grid-cols-2 gap-6 mt-6" data-id="element-1746">
                        <div data-id="element-1747">
                          <label htmlFor="loanAmount" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1748">
                            Loan Amount (KSh) *
                          </label>
                          <input type="number" id="loanAmount" name="loanAmount" required aria-required="true" min="50000" max="10000000" step="10000" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="100000" data-id="element-1749" />
                        </div>

                        <div data-id="element-1750">
                          <label htmlFor="loanPeriod" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1751">
                            Loan Period (Months) *
                          </label>
                          <input type="number" id="loanPeriod" name="loanPeriod" required aria-required="true" min="6" max="60" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="24" data-id="element-1752" />
                        </div>
                      </div>

                      <div className="mt-6" data-id="element-1753">
                        <label htmlFor="loanPurpose" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1754">
                          Purpose of Loan *
                        </label>
                        <textarea id="loanPurpose" name="loanPurpose" required aria-required="true" rows={4} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" placeholder="Describe how you plan to use the loan..." data-id="element-1755" />
                      </div>
                    </div>
                  </div>}

                {currentStep === 2 && <div className="space-y-6" data-id="element-1756">
                    <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-1757">
                      Collateral & Documentation
                    </h2>

                    {/* Car Details (if logbook loan) */}
                    {loanType === 'logbook' && <div className="bg-primary-50 border-2 border-primary-200 rounded-xl p-6 mb-6" data-id="element-1758">
                        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1759">
                          Vehicle Details
                        </h3>

                        <div className="grid md:grid-cols-2 gap-6" data-id="element-1760">
                          <div data-id="element-1761">
                            <label htmlFor="carMake" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1762">
                              Make *
                            </label>
                            <input type="text" id="carMake" name="carMake" required={loanType === 'logbook'} aria-required={loanType === 'logbook'} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none bg-white" placeholder="e.g., Toyota" data-id="element-1763" />
                          </div>

                          <div data-id="element-1764">
                            <label htmlFor="carModel" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1765">
                              Model *
                            </label>
                            <input type="text" id="carModel" name="carModel" required={loanType === 'logbook'} aria-required={loanType === 'logbook'} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none bg-white" placeholder="e.g., Corolla" data-id="element-1766" />
                          </div>
                        </div>

                        <div className="grid md:grid-cols-2 gap-6 mt-6" data-id="element-1767">
                          <div data-id="element-1768">
                            <label htmlFor="carYear" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1769">
                              Year of Manufacture *
                            </label>
                            <input type="number" id="carYear" name="carYear" required={loanType === 'logbook'} aria-required={loanType === 'logbook'} min="1990" max={new Date().getFullYear()} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none bg-white" placeholder="2018" data-id="element-1770" />
                          </div>

                          <div data-id="element-1771">
                            <label htmlFor="carMileage" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1772">
                              Current Mileage (KM) *
                            </label>
                            <input type="number" id="carMileage" name="carMileage" required={loanType === 'logbook'} aria-required={loanType === 'logbook'} min="0" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none bg-white" placeholder="50000" data-id="element-1773" />
                          </div>
                        </div>

                        <div className="mt-6" data-id="element-1774">
                          <label htmlFor="carCondition" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1775">
                            Vehicle Condition *
                          </label>
                          <select id="carCondition" name="carCondition" required={loanType === 'logbook'} aria-required={loanType === 'logbook'} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none bg-white" data-id="element-1776">
                            <option value="" data-id="element-1777">Select condition...</option>
                            <option value="excellent" data-id="element-1778">Excellent</option>
                            <option value="good" data-id="element-1779">Good</option>
                            <option value="fair" data-id="element-1780">Fair</option>
                          </select>
                        </div>
                      </div>}

                    {/* Documentation */}
                    <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-1781">
                      Required Documents
                    </h3>

                    <div data-id="element-1782">
                      <label htmlFor="idDocument" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1783">
                        National ID (Front & Back) *
                      </label>
                      <input type="file" id="idDocument" name="idDocument" accept="image/*,.pdf" required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" data-id="element-1784" />
                    </div>

                    <div data-id="element-1785">
                      <label htmlFor="kraPin" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1786">
                        KRA PIN Certificate *
                      </label>
                      <input type="file" id="kraPin" name="kraPin" accept="image/*,.pdf" required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" data-id="element-1787" />
                    </div>

                    <div data-id="element-1788">
                      <label htmlFor="bankStatements" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1789">
                        Bank Statements (Last 3 Months) *
                      </label>
                      <input type="file" id="bankStatements" name="bankStatements" accept=".pdf" required aria-required="true" className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" data-id="element-1790" />
                    </div>

                    {loanType === 'logbook' && <div data-id="element-1791">
                        <label htmlFor="logbook" className="block text-sm font-semibold text-gray-700 mb-2" data-id="element-1792">
                          Car Logbook *
                        </label>
                        <input type="file" id="logbook" name="logbook" accept="image/*,.pdf" required={loanType === 'logbook'} aria-required={loanType === 'logbook'} className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:ring-2 focus:ring-primary-500 focus:border-primary-500 outline-none" data-id="element-1793" />
                      </div>}
                  </div>}

                {/* Navigation Buttons */}
                <div className="flex justify-between mt-8 pt-6 border-t border-gray-200" data-id="element-1794">
                  {currentStep > 1 && <button type="button" onClick={() => setCurrentStep(currentStep - 1)} className="flex items-center gap-2 px-6 py-3 text-gray-700 hover:text-primary-600 font-semibold transition-colors duration-200" data-id="element-1795">
                      <ArrowLeft size={20} aria-hidden="true" data-id="element-1796" />
                      Previous
                    </button>}

                  {currentStep < 2 ? <button type="button" onClick={() => setCurrentStep(currentStep + 1)} className="ml-auto flex items-center gap-2 px-6 py-3 bg-primary-600 hover:bg-primary-700 text-white font-semibold rounded-lg transition-all duration-300" data-id="element-1797">
                      Next
                      <ArrowRight size={20} aria-hidden="true" data-id="element-1798" />
                    </button> : <button type="submit" className="ml-auto px-8 py-3 bg-primary-600 hover:bg-primary-700 text-white font-bold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl" data-id="element-1799">
                      Submit Application
                    </button>}
                </div>
              </form>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-1800" />
    </div>;
};